import styled from 'styled-components';

export const Container = styled.div`
  max-width: 1220px;
  width: 100%;
  min-height: 100%;
  padding: 0 7px;
  margin: 0 auto;
`
